import React, {useRef, useEffect, useState, useContext} from 'react';
import {Handle} from 'reactflow';
//import {Handle} from 'react-flow-renderer';
import {useSelector, shallowEqual} from 'react-redux';
import Select from 'react-select';

import {Chatbot} from '../../states/actions';
import {onEdit, onSetStart, onClose, onRemove, isLightColor} from '../../helpers/block-helper';
import {ColorPicker} from '../ColorPicker';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import {User} from '../../states/actions';
import ClassicEditor from 'ckeditor5-custom-build';
import {InputComponent, SelectComp, TextareaComponent, PreviewComponent, NodeComponent} from './Components'
import { GlobalStateContext } from '../GlobalState';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';
import {axios} from '../../libs';


export const PaymentBlock = React.memo((node) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);  


  const {block, start, review, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress};
  const optionSelectRef = useRef(null);
  const {_id} = useSelector(User.get());

  const [previewMode, setPreviewMode] = useState(globalState.preview ? undefined : false);

  useEffect(() => {
    setPreviewMode(globalState.preview);
}, [globalState.preview]);

  if (!block) {
    return null;
  }


  const variableOptions = Chatbot.getBlockVariables();
  const {
    data,
  } = block;
  const {backgroundColor: bgColor, textColor: txtColor} = data.meta;
  const backgroundColor = bgColor ?? '#2a3f54';
  const textColor = txtColor ?? (isLightColor(backgroundColor) ? '#000000' : '#ffffff');

  return (
    <>
      {!previewMode &&(
        <NodeComponent bot={bot} block={block} name="Payment" icon="payment" data={data} node={node} start={start} />

      )}
      {previewMode &&(
        // <div className={`block-body node`} onClick={review ? null : () => onEdit(node)}>
         <PreviewComponent bot={bot} data={data} node={node} start={start}/>
        // </div>

      )}
    </>
  );
});


export const PaymentEditor = ({nodeid, block, data, variableoptions}) => {

  let variables_paymenttype = [
    {
      label: 'Payment Initation',
      value: 'paymentInitiation',
      content: 'paymentInitiation',
    },
    {
      label: 'Card Payments',
      value: 'cardPayments',
      content: 'cardPayments',
    },
    {
      label: 'Buy now pay later',
      value: 'bnpl',
      content: 'bnpl',
      
    }
  ];

  let billing_type = [
    {
      label: 'Platform',
      value: 'generate',
      content: 'generate',
    },
    {
      label: 'User',
      value: 'user',
      content: 'user',
    },
  ];

  const [crmUsers, setCrmUsers] = useState([]);
  const [crmUsersLoading, setCrmUsersLoading] = useState(false);

  useEffect(() => {
    if (data.billingtype !== 'user') {
      return;
    }
    let cancelled = false;
    const fetchCrmUsers = async () => {
      try {
        setCrmUsersLoading(true);
        const users = await axios.get('/projects/crm-users/all');
        if (!cancelled) {
          setCrmUsers(Array.isArray(users) ? users.filter((u) => u.role === 'lawyer') : []);
        }
      } catch (err) {
        console.error('Error fetching CRM users for payment block:', err);
      } finally {
        if (!cancelled) {
          setCrmUsersLoading(false);
        }
      }
    };
    fetchCrmUsers();
    return () => {
      cancelled = true;
    };
  }, [data.billingtype]);

  const partnerOptions = crmUsers.map((user) => ({
    label: `${user.firstName} ${user.lastName}${user.partner_company_name ? ` (${user.partner_company_name})` : ''}`,
    value: user.user_no,
    content: user.user_no,
  }));
  let invoicing_type = [
    {
      label: 'invoice',
      value: 'invoice',
      content: 'invoice',
    },
    {
      label: 'prepayment',
      value: 'prepayment',
      content: 'prepayment',
    },
  ];

  let montonio_shop = [
    {
      label: 'Hugo.legal platform (scoro)',
      value: 'scoro',
      content: 'scoro',
    },
    {
      label: 'Hugo.legal (hugo crm)',
      value: 'hugocrm',
      content: 'hugocrm',
    },
  ];

    const handleBlur = (e) => {   
      Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
    };
 
    return (
      <>
         

            <div className='section'>PAYMENT</div>

            <SelectComp data={data} name="Montonio shop" dataname="montonio_shop" placeholder="Select" options={montonio_shop} block={block} value="value"/>


            <SelectComp data={data} name="Invoice method (sequence)" dataname="billingtype" placeholder="Select" options={billing_type} block={block} value="value"/>
            <SelectComp data={data} name="Invoicing Type" dataname="invoicingtype" placeholder="Select" options={invoicing_type} block={block} value="label"/>


            {data.billingtype === 'user' && (
              <>
                <SelectComp
                  data={data}
                  name="Partner"
                  dataname="partner_id"
                  placeholder={crmUsersLoading ? 'Loading...' : 'Select partner'}
                  options={partnerOptions}
                  block={block}
                  value="value"
                />
                <InputComponent
                  data={data}
                  name="Payment description"
                  dataname="payment_description"
                  onBlur={handleBlur}
                />
                <small className="text-muted">Use {'{variable_name}'} for chat variables</small>
                <br /><br />
              </>
            )}

            {/* <InputComponent data={data} name="Billing ID variable" dataname="merchantref" onBlur={handleBlur}/> */}

            {/* <InputComponent data={data} name="Price" dataname="amount" onBlur={handleBlur}/> */}
            <SelectComp data={data} name="Price" dataname="amount" placeholder="Select price" options={variableoptions} block={block} value="label"/>
{/*             <SelectComp data={data} name="Payment Method" dataname="paymenttype" placeholder="Select" options={variableoptions} block={block} value="label"/>
 */}
<SelectComp data={data} name="Payment Period" dataname="paymentperiod" placeholder="Select" options={variableoptions} block={block} value="label"/>
<br/><br/>


            {/* TODO fix save option value to label and remove optional value, check if there are some that work differently */}

            <div className='section'>CLIENT</div>

            <SelectComp data={data} name="First Name" dataname="first_name" placeholder="Select" options={variableoptions} block={block} value="label"/>
          
            <SelectComp data={data} name="Last Name" dataname="last_name" placeholder="Select" options={variableoptions} block={block} value="label"/>

            <SelectComp data={data} name="Email" dataname="email" placeholder="Select" options={variableoptions} block={block} value="label"/>

        

            <SelectComp data={data} name="Service name" dataname="service" placeholder="Select" options={variableoptions} block={block} value="label"/>

            <br/><br/>
            <div className='section'>TASK DETAILS</div>
            
            <SelectComp data={data} name="Task Description" dataname="task_description" placeholder="Select or enter task description" options={variableoptions} block={block} value="label"/>
            
            <SelectComp data={data} name="Task Duration (mm)" dataname="task_duration" placeholder="Select or enter duration" options={variableoptions} block={block} value="label"/>

            {/* <SelectComp data={data} name="Type" dataname="paymenttype" placeholder="Select" options={variables_paymenttype} block={block} value="value"/>
            */}

      </>
    )
}
